var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"text-h3 title"},[_vm._v(" "+_vm._s(_vm.$t("history"))+" ")]),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.$t("charge_history"))+" ")]),_c('charge-session',{attrs:{"show-details":false,"per-page-options":[5, 20, 50],"headers":_vm._headers},on:{"fetch":(v) => (_vm.filters = v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }